import { actionType } from '../actions/article';
import baseInitState from '../baseInitState';
import baseReducer from '../baseReducer';

const initState = {
  ...baseInitState,
};

export default function article(state = initState, action) {
  switch (action.type) {
    default:
      return baseReducer(state, action, actionType);
  }
}
